import React from 'react';
import { Button, Box, Tooltip } from '@mui/material';
import { EmojiEvents as TrophyIcon } from '@mui/icons-material';

/**
 * Componente de ações para a página de notas.
 * Reproduz os botões da implementação original de Grades.js,
 * mas de forma organizada e reutilizável.
 */
export const GradesActions = ({
  loading,
  disabled,
  onUpdateVisibility, // Mantido por compatibilidade, mas não é mais usado
  onOpenFinalGradesModal,
  onValidateAverages,
  onOpenTalentoAutentico,
  failedFinalSendCount = 0,
  onRetryFailedFinalGrades,
  retryFailuresCooldownSecondsLeft = 0,
}) => {
  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      {/* Botão "Atualizar Visibilidade" removido - agora o checkbox "selecionar todos" salva automaticamente */}

      <Tooltip 
        title="O campo 'Média' será submetido ao Sponte de forma imediata"
        arrow
        placement="top"
      >
        <span>
          <Button
            variant="contained"
            color="success"
            onClick={onOpenFinalGradesModal}
            disabled={loading || disabled}
          >
            CALCULAR NOTAS FINAIS
          </Button>
        </span>
      </Tooltip>

      {failedFinalSendCount > 0 && typeof onRetryFailedFinalGrades === "function" && (
        <Tooltip
          title={
            retryFailuresCooldownSecondsLeft > 0
              ? `Aguarde ${retryFailuresCooldownSecondsLeft}s para não repetir erro (limite da API). Depois você poderá reenviar só os ${failedFinalSendCount} aluno(s) com falha.`
              : "Envia ao Sponte apenas os alunos que falharam na última tentativa (menos requisições que refazer a turma inteira)"
          }
          arrow
          placement="top"
        >
          <span>
            <Button
              variant="outlined"
              color="warning"
              onClick={onRetryFailedFinalGrades}
              disabled={
                loading ||
                disabled ||
                retryFailuresCooldownSecondsLeft > 0
              }
            >
              {retryFailuresCooldownSecondsLeft > 0
                ? `AGUARDAR ${retryFailuresCooldownSecondsLeft}s (${failedFinalSendCount})`
                : `REENVIAR FALHAS (${failedFinalSendCount})`}
            </Button>
          </span>
        </Tooltip>
      )}

      <Tooltip 
        title="Verifica se as médias do Sponte estão iguais às médias do aplicativo"
        arrow
        placement="top"
      >
        <span>
          <Button
            variant="contained"
            color="info"
            onClick={onValidateAverages}
            disabled={loading || disabled}
          >
            VERIFICAR MÉDIAS
          </Button>
        </span>
      </Tooltip>

      <Tooltip 
        title="Acessa o sistema de reconhecimento de talentos dos alunos"
        arrow
        placement="top"
      >
        <span>
          <Button
            variant="contained"
            color="secondary"
            onClick={onOpenTalentoAutentico}
            disabled={loading || disabled}
            startIcon={<TrophyIcon />}
          >
            TALENTO AUTÊNTICO
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};

